{
  "features": {
    "config": {
      "title": "어린 양의 동료",
      "subtitle": "Twitch 연동 설정",
      "sections": {
        "premiumSkins": {
          "title": "프리미엄 스킨",
          "description": "이 확장요소를 사용하면 귀하의 시청자들이 게임 내에 추종자로서 나타납니다. 시청자들은 추종자로서 커스터마이징을 할 수 있고, 프리미엄 스킨을 위해 Bits를 사용할 수 있습니다. 원하는 양의 Bits를 선택해 프리미엄 스킨의 가격을 설정하거나, 혹은 스킨을 공짜로 두어 누구나 사용할 수 있게 할 수 있습니다.",
          "noBitsOption": "Bits 없음. 추종자들에게 프리미엄 스킨을 무료로 사용하게 할 것입니다.",
          "bitsFeatureNotAvailable": "귀하의 채널은 Bits를 사용할 수 없습니다. 귀하의 시청자들은 Bits를 사용하는 스킨을 제외한 모든 스킨을 사용할 수 있습니다."
        }
      },
      "actions": {
        "save": "변경요소 저장"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "{{channelName}}님의 교단에 입교!",
        "subtitle": "추첨에 당첨되었습니다!",
        "timeRemaining": "남은 시간: {{time}}",
        "message": "본 교단에 합류하면 여러가지 이점이 있습니다. 악마적 추가 외형의 성장 가능성, Cult of the Lamb의 라이브 게임에 참여할 수 있는 영광, 그리고 제물이 될 영광입니다!",
        "viewerLinkCta": "입교를 위해서, {ID를 입력해주세요}.",
        "actions": {
          "joinRaffle": "입교하겠습니다.",
          "joinRaffleViewerHasAlreadyJoined": "당신은 추첨에 참여했습니다.",
          "dismissRaffle": "됐어요, 안 할래요.",
          "dismissRaffleViewerHasAlreadyJoined": "닫기"
        },
        "raffleJoinedMessage": "그대의 의지를 알겠습니다. 교단에 입교하기로 선택하셨다면, 곧 통지가 있을 것입니다. 이 창을 닫으셔도 됩니다."
      },
      "followerBuilder": {
        "title": "추종자 만들기",
        "steps": {
          "intro": {
            "message": "교단에 들어왔습니다! 귀하가 여기서 만든 추종자들이 게임에 나타납니다. 귀하의 추종자는 결국 어떻게든 죽는다는 걸 알아두십시오. 하지만 최소한 대의를 위해 몸바치는 것입니다.",
            "actions": {
              "goToNextStep": "추종자 만들기"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "계속"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "스킨으로 돌아가기",
              "goToNextStep": {
                "variationsForSkin": "계속",
                "noVariationsForSkin": "내 추종자 만들기"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "색으로 돌아가기",
              "goToNextStep": "내 추종자 만들기"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "도움",
      "hinder": "방해",
      "hhVotingFlyout": {
        "title": "도움 혹은 방해",
        "message": "투표해주세요",
        "timeRemaining": "남은 시간: {{time}}",
        "voteCount": "투표 수: {{amount}}"
      },
      "outcomeVotingFlyout": {
        "title": "{{helpOrHinder}} {{channelName}}에 귀하의 표를 던져주세요!",
        "timeRemaining": "남은 시간: {{time}}"
      }
    }
  }
}
